import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "./klass.VuwTextField";

/**
 * VuwNumberField (extends VuwTextField)
 * @options
 * - {Boolean} required
 * - {Number} ltd
 * - {String} placeholder
 * - {String} unit
 */
vuwer.appendKlass("VuwNumberField", {
	inpType: "number",
	inpClassList: ["inp", "inp-txt", "inp-num"],
	_html5Input: Klass("Console").device[0] === "sp",
	
	_initialize: function _initialize(opt) {
		if( Klass("VuwNumberField").parent._initialize.call(this, opt) ) {
			// [必須バリデーションの上書き]
			this._validations.required = val => {
				return !this.required || !!val || val === 0;
			};
			
			// [エラーメッセージの上書き]
			// 文字数制限
			this.errorMessages.ltd = this.errorMessages.ltd.replace("文字", "桁");
			
			// [ltd の動的な切り替え用]
			this.onChangeState(function(state) {
				if( this.$inp.length && state.hasOwnProperty("ltd") ) {
					if( u_.isNumber(state.ltd) && state.ltd > 0 && $.fn.mask ) {
						this.$inp.data( "mask", new Array(state.ltd + 1).join("0") );
						this.$inp.mask( this.$inp.data("mask") );
					}
				}
			});
			
			return this;
		} else {
			return false;
		}
	},
	
	getInpReady: function getInpReady($self) {
		Klass("VuwNumberField").parent.getInpReady.call(this, $self);
		if(this.$inp.length) {
			$self.on("keydown", ".inp-num", function(e) {
				var val = parseFloat(this.value || 0);
				if(e.keyCode === 38) {
					this.value = val + 1;
					$(this).trigger("change", [false, "monitor"]);
				} else
				if(e.keyCode === 40 && val) {
					this.value = val - 1;
					$(this).trigger("change", [false, "monitor"]);
				}
			});
			
			// **** attachPlugin ****
			// [mask]
			if(this.ltd && $.fn.mask) {
				this.$inp.mask( String( this.$inp.data("mask") ) );
			}
		}
		return this;
	},
	
	setVal: function setVal(value, antiTriggerChange) {
		u_.isNumber(value) || ( value = parseInt(value) );
		isNaN(value) && (value = "");
		
		Klass("VuwField").prototype.setVal.call(this, value);
		
		if(this.$inp.length && !antiTriggerChange) {
			this.$inp.val( String(value) ).trigger("change", [true]);
		}
		return this;
	},
	
	_renderField: function _renderField() {
		var
			attr = {
				type: this._html5Input ? "tel" : "text",
				name: this.paramKey,
				id: ["inp", this.idStr].join("_")
			},
			elms = [];
		
		// for mask plugin
		if(this.ltd) {
			attr["data-mask"] = new Array(this.ltd + 1).join("0");
		}
		
		// set placeholder
		if( this.placeholder && u_.isString(this.placeholder) ) {
			attr.placeholder = this.placeholder;
		} else
		if(this.ltd) {
			attr.placeholder = attr["data-mask"];
		}
		
		elms.push( $("<input/>").addClass( this.inpClassList.join(" ") ).attr(attr) );
		if( !!this.unit && u_.isString(this.unit) ) {
			elms.push( $("<span/>").addClass("unit").html( $.parseHTML(this.unit) ) );
		}
		return $.fn.append.apply(
			$("<fieldset/>").addClass("vuw-field field-num").attr({
				"id": ["field", this.idStr].join("_"),
				"data-name": this.paramKey
			}),
			elms
		);
	}
}, "VuwTextField");
